import React, { useEffect, useRef, memo } from 'react';

/**
 * Stocks Above Moving Average TradingView Widget Component
 * 
 * Displays an interactive TradingView chart showing the percentage of stocks
 * above their 50-day moving average (INDEX:S5FI)
 * Designed for the "Buy Low, Sell High" strategy section
 */
function StocksAboveMAWidget() {
  const containerRef = useRef(null);

  useEffect(() => {
    // Capture the current ref value for cleanup
    const currentContainer = containerRef.current;
    
    // Clear any existing content
    if (currentContainer) {
      currentContainer.innerHTML = '';
    }

    // Create and configure the script
    const script = document.createElement("script");
    script.src = "https://s3.tradingview.com/external-embedding/embed-widget-advanced-chart.js";
    script.type = "text/javascript";
    script.async = true;
    
    // Use proper JSON configuration
    script.innerHTML = JSON.stringify({
        "autosize": true,
        "symbol": "INDEX:S5FI",
        "interval": "D",
        "timezone": "Etc/UTC",
        "theme": "dark",
        "style": "0",
        "locale": "en",
        "hide_top_toolbar": true,
        "allow_symbol_change": true,
        "hide_volume": true,
        "support_host": "https://www.tradingview.com",
        "container_id": "stocks_above_ma_widget",
        // Try using drawings instead of studies
        "drawings": [
          {
            "type": "horizontal_line",
            "value": 15,
            "color": "#FFFFFF",
            "linewidth": 2,
            "linestyle": "solid"
          }
        ]
      });

    // Add error handling
    script.onerror = () => {
      console.error('Failed to load TradingView widget script for Stocks Above MA');
    };

    script.onload = () => {
      console.log('Stocks Above MA TradingView widget script loaded successfully');
    };

    // Append script to container
    if (currentContainer) {
      currentContainer.appendChild(script);
    }

    // Cleanup function
    return () => {
      if (currentContainer) {
        currentContainer.innerHTML = '';
      }
    };
  }, []);

  return (
    <div className="stocks-ma-tradingview-widget-container" style={{ height: "100%", width: "100%" }}>
      <div 
        ref={containerRef} 
        id="stocks_above_ma_widget"
        style={{ height: "calc(100% - 32px)", width: "100%" }}
      />
      <div className="tradingview-widget-copyright">
        <a 
          href="https://www.tradingview.com/" 
          rel="noopener noreferrer" 
          target="_blank"
          className="blue-text"
        >
          Track all markets on TradingView
        </a>
      </div>
    </div>
  );
}

export default memo(StocksAboveMAWidget); 